import {
  assignValue,
  assignProps,
  findResultInCategory,
  findSelected,
} from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import crushRequestFields from '../../forms/state/state';
import findRequestWorkspaces from './state';
import actions from '../constants';
import { findAllRequestsInCategories, findRequest, resetWorkspaceAttributes } from '../../state/state';

const fetchRequestWorkspaces = withDraft((draft, { category, code, location }) => {
  const { item, workspaces } = findRequestWorkspaces(draft, { category, code });
  item.workspace_location = location;
  workspaces.readStatus = states.PENDING;
  workspaces.readErrors = [];
});

const showRequestWorkspaces = withDraft((draft, { category, code, results }) => {
  const { item, workspaces } = findRequestWorkspaces(draft, { category, code });
  assignProps(workspaces, {
    results: results.map((workspace) => ({
      ...workspace,
      selected: workspace.uuid === item.workspace_uuid,
    })),
    readStatus: states.SUCCESS,
    readErrors: [],
  });
  item.workspace_uuid = null;
});

const showRequestWorkspacesError = withDraft((draft, action) => {
  const { workspaces } = findRequestWorkspaces(draft, action);
  assignProps(workspaces, { readStatus: states.ERROR, readErrors: [responseError(action)] });
});

const fetchRequestLocations = withDraft((draft, action) => {
  const { locations } = findRequestWorkspaces(draft, action);
  if (locations) {
    locations.readStatus = states.PENDING;
    locations.readErrors = [];
  }
});

const showRequestLocations = withDraft((draft, { category, code, results }) => {
  const { item, locations } = findRequestWorkspaces(draft, { category, code });
  assignProps(locations, { results, readStatus: states.SUCCESS, readErrors: [] });
  item.workspace_location = results.length === 1 ? results[0].value : null;
});

const showRequestLocationsError = withDraft((draft, action) => {
  const { locations } = findRequestWorkspaces(draft, action);
  assignProps(locations, { readStatus: states.ERROR, readErrors: [responseError(action)] });
});

const toggleRequestWorkspaceSelected = withDraft((draft, action) => {
  const { item, workspaces } = findRequestWorkspaces(draft, action);
  const workspace = findResultInCategory(workspaces, action.uuid, 'uuid');
  const selectedWorkspaces = findSelected(workspaces.results);

  selectedWorkspaces.forEach((d) => assignValue(d, 'selected', false));
  workspace.selected = !workspace.selected;
  if (workspace.selected) {
    item.workspace_requested = false;
  }
  item.isDirty = true;
});

const toggleWorkspaceRequest = withDraft((draft, action) => {
  const { item, workspaces } = findRequestWorkspaces(draft, action);
  const isNew = item.workspace_requested;

  if (!isNew) {
    const selectedWorkspaces = findSelected(workspaces.results);
    selectedWorkspaces.forEach((d) => assignValue(d, 'selected', false));
  }

  item.workspace_requested = !isNew;
  item.isDirty = true;
});

const fetchRequestWorkspace = withDraft((draft, action) => {
  findAllRequestsInCategories(draft, action).forEach((request) => {
    assignProps(request, { workspaceReadStatus: states.PENDING, workspaceReadErrors: [] });
  });
});

const showRequestWorkspace = withDraft((draft, action) => {
  findAllRequestsInCategories(draft, action).forEach((request) => {
    assignProps(request, {
      ...resetWorkspaceAttributes(),
      ...action.result,
      workspaceReadStatus: states.SUCCESS,
      workspaceReadErrors: [],
    });
  });
});

const showRequestWorkspaceError = withDraft((draft, action) => {
  findAllRequestsInCategories(draft, action).forEach((request) => {
    assignProps(request, {
      ...resetWorkspaceAttributes(),
      workspaceReadStatus: states.ERROR,
      workspaceReadErrors: [responseError(action)],
    });
  });
});

const showFormForWorkspaceRequest = withDraft((draft, { code, result }) => {
  const item = findRequest(draft, { category: 'workspaces', code });
  crushRequestFields(item, result);
});

const showWorkspaceFormForRequest = withDraft((draft, {
  category, code, result, workflow,
}) => {
  const item = findRequest(draft, { category, code });
  const sections = { ...result.sections, ...workflow.sections };
  crushRequestFields(item, { sections });
});

export default {
  [actions.FETCH_REQUEST_WORKSPACE]: fetchRequestWorkspace,
  [actions.FETCH_REQUEST_WORKSPACES]: fetchRequestWorkspaces,
  [actions.FETCH_REQUEST_LOCATIONS]: fetchRequestLocations,
  [actions.SHOW_REQUEST_LOCATIONS]: showRequestLocations,
  [actions.SHOW_REQUEST_LOCATIONS_ERROR]: showRequestLocationsError,
  [actions.SHOW_REQUEST_WORKSPACE]: showRequestWorkspace,
  [actions.SHOW_REQUEST_WORKSPACE_ERROR]: showRequestWorkspaceError,
  [actions.SHOW_REQUEST_WORKSPACES]: showRequestWorkspaces,
  [actions.SHOW_REQUEST_WORKSPACES_ERROR]: showRequestWorkspacesError,
  [actions.SHOW_FORM_FOR_WORKSPACE_REQUEST]: showFormForWorkspaceRequest,
  [actions.SHOW_WORKSPACE_FORM_FOR_REQUEST]: showWorkspaceFormForRequest,
  [actions.TOGGLE_REQUEST_WORKSPACE_SELECTED]: toggleRequestWorkspaceSelected,
  [actions.TOGGLE_WORKSPACE_REQUEST]: toggleWorkspaceRequest,
};
